import { render, staticRenderFns } from "./autoKyc.html?vue&type=template&id=460b85c3&scoped=true&"
import script from "./autoKyc?vue&type=script&lang=js&"
export * from "./autoKyc?vue&type=script&lang=js&"
import style0 from "./autoKyc.scss?vue&type=style&index=0&id=460b85c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460b85c3",
  null
  
)

export default component.exports